export default "__VITE_ASSET__27460e90__"